import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withProps } from '../../../../utils/recompose-migration'

import {
  editUserReview as editReview,
  setOrderShownForReview
} from '../../../../redux-api-bridge'

import * as selectors from './selectors'
import ReviewModal from './ReviewModal'

const mapStateToProps = state => ({
  lastOrder: selectors.getLastOrder(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setOrderShownForReview,
      editReview
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({ controlled, lastOrder, selectedOrder }) => ({
    order: controlled ? selectedOrder : lastOrder
  }))
)(ReviewModal)
